const initialState = {
    applicantSubTab: null,
    ambassadorSubTab: null,
    pendingResults: { count: 0, rows: [], appQuestions: [] },
    pendingPagination: {
        sortBy: 'ambassador.createdAt',
        dir: 'desc',
        page: 1,
        limit: 100,
    },

    rejectedResults: { count: 0, rows: [], appQuestions: [] },
    rejectedPagination: {
        sortBy: 'ambassador.updatedAt',
        dir: 'desc',
        page: 1,
        limit: 100,
    },

    nonAmbassadorResults: { count: 0, rows: [] },
    nonAmbassadorPagination: {
        sortBy: 'ambassador.createdAt',
        dir: 'desc',
        page: 1,
        limit: 100,
    },

    ambassadorResults: { count: 0, rows: [], appQuestions: [] },
    ambassadorPagination: {
        sortBy: 'ambassador.approvedDate',
        dir: 'desc',
        page: 1,
        limit: 100,
    },

    allAmbassadorResults: { count: 0, rows: [], appQuestions: [] },
    allAmbassadorPagination: {
        sortBy: 'ambassador.updatedAt',
        dir: 'desc',
        page: 1,
        limit: 100,
    },

    groupResults: { count: 0, rows: [] },
    groupPagination: {
        sortBy: 'group.createdAt',
        dir: 'desc',
        page: 1,
        limit: 100,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'applicant-subtab':
            return { ...state, applicantSubTab: action.payload };

        case 'ambassador-subtab':
            return { ...state, ambassadorSubTab: action.payload };

        case 'pending-results': {
            return { ...state, pendingResults: action.payload };
        }
        case 'pending-pagination': {
            return { ...state, pendingPagination: action.payload };
        }

        case 'rejected-results': {
            return { ...state, rejectedResults: action.payload };
        }
        case 'rejected-pagination': {
            return { ...state, rejectedPagination: action.payload };
        }

        case 'non-ambassador-results': {
            return { ...state, nonAmbassadorResults: action.payload };
        }
        case 'non-ambassador-pagination': {
            return { ...state, nonAmbassadorPagination: action.payload };
        }

        case 'ambassador-results': {
            return { ...state, ambassadorResults: action.payload };
        }
        case 'ambassador-pagination': {
            return { ...state, ambassadorPagination: action.payload };
        }

        case 'all-ambassador-results': {
            return { ...state, allAmbassadorResults: action.payload };
        }
        case 'all-ambassador-pagination': {
            return { ...state, allAmbassadorPagination: action.payload };
        }

        case 'reset-all-page-to-1': {
            return {
                ...state,
                ambassadorPagination: { ...state.ambassadorPagination, page: 1 },
                nonAmbassadorPagination: { ...state.nonAmbassadorPagination, page: 1 },
                allAmbassadorPagination: { ...state.allAmbassadorPagination, page: 1 },
                pendingPagination: { ...state.pendingPagination, page: 1 },
                rejectedPagination: { ...state.rejectedPagination, page: 1 },
                groupPagination: { ...state.groupPagination, page: 1 },
                recommendedContactPagination: { ...state.recommendedContactPagination, page: 1 },
            };
        }

        case 'group-results': {
            return { ...state, groupResults: action.payload };
        }
        case 'group-pagination': {
            return { ...state, groupPagination: action.payload };
        }
        default:
            return state;
    }
};
